import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UpdateClient } from 'src/app/shared/interfaces/client.interface';

@Component({
  selector: 'app-update-client',
  templateUrl: './update-client.component.html',
  styleUrls: ['./update-client.component.scss']
})
export class UpdateClientComponent {
  updateClientForm!: FormGroup;
  successMessage!: string;
  showSuccess!: boolean;
  errorMessage!: string;
  showError!: boolean;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.updateClientForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
    });
  }

  updateClient() {
    const updateClient: UpdateClient = {
      firstName: this.updateClientForm.get('firstName')?.value,
      lastName: this.updateClientForm.get('lastName')?.value
    };
    // if (this.updateClientForm.valid) {
    //   this.authService.updateClient(updateClient).subscribe({
    //     next: () => this.showSuccess = true,
    //     error: (err: HttpErrorResponse) => {
    //       this.showError = true;
    //       this.errorMessage = err.message;
    //     }
    //   })
    // } else {
    //   this.errorMessage = 'Fill all the required field!';
    // }
  }

  hasError(controlName: string, errorName: string) {
    return this.updateClientForm.controls[controlName].hasError(errorName);
  }
}
